import React from 'react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import {
  Box,
  Text,
  CloudinaryImage,
  Inline,
  Link,
} from '@stitch-fix/mode-react';
import { useGetStylistChatPdpPromptQuery } from './getStylistChatPdpPrompt';
import styles from './StylistChatPdpPrompt.module.scss';

const StylistChatPdpPrompt = () => {
  const { data } = useGetStylistChatPdpPromptQuery();
  const stylistChatPdpPrompt =
    data?.client?.stylistConnectContent?.stylistChatPdpPrompt;
  const { ref, EventProvider, reportSelectEvent } = useViewEvent({
    name: 'stylist_connect_promo_module',
    schema: 'view',
  });

  const handleCtaClick = () => {
    reportSelectEvent({
      action_name: 'open_app_store',
      name: 'stylist_connect_promo_module',
      schema: 'select',
    });
  };

  if (!stylistChatPdpPrompt) {
    return null;
  }

  const profilePicture = () => {
    const imageSize = 52;

    if (stylistChatPdpPrompt?.image) {
      return (
        <Box
          width={`${imageSize}px`}
          height={`${imageSize}px`}
          className={styles.image}
          data-testid="stylist-connect-profile-image"
        >
          <CloudinaryImage
            alt={stylistChatPdpPrompt.image?.altText}
            baseUrl={stylistChatPdpPrompt.image?.baseUrl}
            mediaPath={stylistChatPdpPrompt.image?.mediaPath}
            sizes={{
              sm: imageSize,
              md: imageSize,
            }}
            transforms={{
              ar: '1:1',
            }}
          />
        </Box>
      );
    }

    return null;
  };

  return (
    <EventProvider>
      <Box
        mb={{ sm: 2, md: 0 }}
        mt={{ sm: 1, md: 0 }}
        ref={ref}
        variant="promo-dark"
        p={1}
        data-testid="stylist-connect-prompt-module"
        style={{
          display: 'flex',
          alignItems: 'baseline',
          borderRadius: '8px',
        }}
      >
        <Inline spacing={1} vAlign="center">
          {profilePicture()}
          <Link
            onClick={() => handleCtaClick()}
            href={
              stylistChatPdpPrompt?.ctaUrl ||
              'https://www.stitchfix.com/app/open'
            }
          >
            <Text setting="eyebrow-small" data-testid="eyebrow" spacingBottom>
              {stylistChatPdpPrompt.eyebrow}
            </Text>
            <Text setting="title-xsmall" data-testid="headline">
              {stylistChatPdpPrompt.headline}
            </Text>
          </Link>
        </Inline>
      </Box>
    </EventProvider>
  );
};

export default StylistChatPdpPrompt;
